



























import { mapGetters } from 'vuex'

// Services
import { UserService } from '@/services'

enum NotificationChoice {
  EMAIL = 'EMAIL',
  SMS = 'SMS',
}

export default {
  name: 'Communication',

  data() {
    return {
      loading: false,

      input: {
        labelMonthlyEmail: 'Email me when new offers are available',
        labelMonthlySMS: 'Text me when new offers are available',
        labelEmailReminderExpiringOffer: 'Email me reminders of expiring offers',
        labelSMSReminderExpiringOffer: 'Text me reminders of expiring offers',
        labelEmailReminderNeedsProof: 'Email me reminders for missing uploads on my redeemed offers',
        labelSMSReminderNeedsProof: 'Text me reminders for missing uploads on my redeemed offers',
      },

      notificationChoice: {
        email: NotificationChoice.EMAIL,
        sms: NotificationChoice.SMS,
      },
    }
  },

  computed: {
    ...mapGetters('auth', ['user']),
  },

  mounted() {
    this.user.need_proof_notification_choice = this.user.need_proof_notification_choice || NotificationChoice.EMAIL
    this.user.expiring_notification_choice = this.user.expiring_notification_choice || NotificationChoice.EMAIL
  },

  methods: {
    saveCommunicationPreferences() {
      this.loading = true

      UserService.setCommunication(
        this.user.survey_notification_email,
        this.user.survey_notification_sms,
        this.user.need_proof_notification_choice,
        this.user.expiring_notification_choice
      ).then(() => {
        this.loading = false
        this.$toast.success('Communication preferences saved')
      })
    },
  },
}
